// extracted by css-extract-rspack-plugin
export default {"nav":"nav-HV7dQw"};